export default __webpack_public_path__ + "static/media/bulb.f236426f.svg";